export default __webpack_public_path__ + "static/media/uolhost.cec030ba.svg";